export const routesTanitim = [
  {
    path: "/unvantanitim",
    name: "unvantanitim",
    component: () => import("@/views/unvantanitim/index.vue"),
    meta: {
      public: false,
      title: "unvantanitim.Ünvan Tanıtım",
      yetki: { k: [1020402] },
    },
  },
]
